// Hub page content for the Visitor & Working Holiday group.
// Sourced from docs/research/australian-visa-pathways.md §7 and §8.

const visitorWorkingHolidayHub = {
  groupSlug: "visitor-working-holiday",
  eyebrow: "Visitor & Working Holiday",
  heading: "Visitor and working holiday visas",
  intro:
    "Whether you want to holiday in Australia, visit family, attend business meetings, or work and travel for a year, there is a short-stay visa to suit. These are temporary visas, and the conditions attached to them matter. We prepare your documents and get your file application-ready, then match you with a registered migration agent who confirms the right visa and stream and lodges it.",

  howItWorks: {
    heading: "How short-stay visas work",
    steps: [
      {
        title: "Match the purpose",
        detail:
          "A registered migration agent identifies the right visa and stream for your reason to travel.",
      },
      {
        title: "Meet the requirements",
        detail:
          "Each visa has its own age, funds, sponsor, or eligibility rules.",
      },
      {
        title: "Apply",
        detail:
          "We organise a thorough, complete file, and a registered migration agent lodges it. The Department of Home Affairs decides.",
      },
      {
        title: "Know your conditions",
        detail:
          "A registered migration agent explains conditions like No Further Stay so there are no surprises onshore.",
      },
    ],
  },

  atAGlance: {
    heading: "Compare the short-stay visas",
    columns: ["Visa", "Best for", "Type", "Notable condition"],
    rows: [
      {
        serviceSlug: "visitor-600",
        cells: [
          "Visitor (600)",
          "Tourism, family, or business visits",
          "Temporary",
          "Often No Further Stay",
        ],
      },
      {
        serviceSlug: "sponsored-family-visitor",
        cells: [
          "Sponsored Family Visitor",
          "Visits backed by an Australian relative",
          "Temporary",
          "May require a security bond",
        ],
      },
      {
        serviceSlug: "working-holiday",
        cells: [
          "Working Holiday (417/462)",
          "Young travellers working and touring",
          "Temporary",
          "Extensions need specified work",
        ],
      },
    ],
  },

  faqs: [
    {
      q: "Can these visas lead to permanent residence?",
      a: "No, they are all temporary with no direct PR pathway. Some people later move on to study, skilled, or employer-sponsored visas. If you decide to stay longer term, we match you with a registered migration agent who can advise on those.",
    },
    {
      q: "What is the No Further Stay condition?",
      a: "It is condition 8503, which often applies to visitor visas and prevents you applying for most other visas while in Australia. Waivers are rare. A registered migration agent explains whether it applies to you before you travel.",
    },
    {
      q: "Can I study on a visitor or working holiday visa?",
      a: "Only in limited ways. Recent rules generally stop visitor holders applying for a student visa onshore, and working holiday study is limited. If study is your goal, a registered migration agent can advise on an offshore student application, and we prepare the documents for it.",
    },
  ],

  lastVerified: "13 July 2026",
};

export default visitorWorkingHolidayHub;
